import EmployeePayRollForSignWidget from "@/pages/dashboard/widgets/EmployeePayRollForSignWidget.vue";
import EmployeeVacationDayWidget from "@/pages/dashboard/widgets/EmployeeVacationDayWidget.vue";
import EmployeeVacationForecastWidget from "@/pages/dashboard/widgets/EmployeeVacationForecastWidget.vue";
import ResponsiblePayRollForSignWidget from "@/pages/dashboard/widgets/ResponsiblePayRollForSignWidget.vue";

export {
  EmployeePayRollForSignWidget,
  EmployeeVacationDayWidget,
  EmployeeVacationForecastWidget,
  ResponsiblePayRollForSignWidget,
};
